import { useContext, useState } from 'react';
import AppContext from '../../../AppContext';
import { reportViewLabel } from '../../model/ReportView';
import styles from './ReportView.module.css';
import { MdExpandLess, MdExpandMore } from 'react-icons/md';

interface ReportViewProps {
  reportViewCode: string;
  children?: React.ReactNode;
}

export default function ReportView({ reportViewCode, children }: ReportViewProps) {
  const { riskRepository, setRiskRepository, setNavIsOpen } = useContext(AppContext);
  const [expanded, setExpanded] = useState(false);

  function scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  function changeReportView(reportViewOption: string) {
    setRiskRepository(reportViewOption);
    setNavIsOpen(false);
    scrollToTop();
  }

  return (
    <li
      data-testid={`report-view-${reportViewCode}`}
      id={`report-view-${reportViewCode}`}
      className={styles.nested_container}>
      <div className={riskRepository === reportViewCode ? styles.active : styles.inactive}>
        <div className={styles.nested_title} onClick={() => changeReportView(reportViewCode)}>
          {reportViewLabel(reportViewCode)}
        </div>

        {children && (
          <div
            onClick={() => setExpanded(!expanded)}
            className={styles.expand}
            data-testid={`report-view-toggle-${reportViewCode}`}
            id={`report-view-toggle-${reportViewCode}`}>
            {expanded ? <MdExpandLess size={'1.5rem'} /> : <MdExpandMore size={'1.5rem'} />}
          </div>
        )}
      </div>
      {expanded && children}
    </li>
  );
}
